import React, { useState, useEffect } from 'react';
import { makeStyles, Button } from '@material-ui/core';
import Drawer from '@material-ui/core/Drawer';
import CloseIcon from '@material-ui/icons/Close';
import clsx from 'clsx';
import FlagstoneTheme from '../../../../Config/flagstoneTheme';
import Switch from '@material-ui/core/Switch';
import SelectZoneContainer from './SelectZoneContainer'
import SelectScissorsContainer from './SelectScissorsContainer';
import PlayArrowRoundedIcon from '@material-ui/icons/PlayArrowRounded';
import { productionOrderStates as state } from '../../../../Config/productionOrderStates'
import AlertDialog from '../../../Shared/Dialogs/AlertDialog'
import { dataService } from '../../../../Services/data.service'
import { toast } from 'react-toastify';
import { machineScissorZone } from '../../../../Config/constants'
import { scissorTypes } from '../../../../Config/scissorStates'
import StartOrderDialog from '../../../Shared/Dialogs/StartOrderDialog';
import OrderLengthDialog from '../../../Shared/Dialogs/OrderLengthDialog';
import { useTranslation } from 'react-i18next';
import { haveSameBOMIn } from '../../../../Helpers/OrderInfoHelper';
import UnMatchingBOMDialog from '../../../Shared/Dialogs/UnMatchingBOMDialog';

export default function OrderDetailStateDrawer(props) {
    const classes = useStyles();
    const { t } = useTranslation();

    const [scissorZones, setScissorZones] = useState([])
    const [multipleOrders, setMultipleOrders] = useState(true)
    const [completeWorkstationOrder, setCompleteWorkstationOrder] = useState(false)
    const [canStartOrder, setCanStartOrder] = useState(false)

    const [selectedZones, setSelectedZones] = useState([])
    const [runningOrPausedDialogOpen, setRunningOrPausedDialogOpen] = useState(false)
    const [startOrderDialogOpen, setStartOrderDialogOpen] = useState(false)
    const [orderLengthDialogOpen, setOrderLengthDialogOpen] = useState(false)
    const [dialogTitle, setDialogTitle] = useState(null)
    const [dialogContext, setDialogContext] = useState(null)
    const [upperScissorStatus, setUpperScissorStatus] = useState(null)
    const [lowerScissorStatus, setLowerScissorStatus] = useState(null)
    const [zonesWithScissors, setZonesWithScissors] = useState([])
    const [orders, setOrders] = useState([])
    const [startProductionOrder, setStartProductionOrder] = useState(false)
    const [orderStringList, setOrderStringList] = useState([])
    const [unMatchingBOMDialogOpen, setUnMatchingBOMDialogOpen] = useState(false)

    useEffect(() => {

        dataService.getMachinesWithScissorStatusInfo().then(workstationsWithScissorStatusses => {

            let workstation = workstationsWithScissorStatusses.find(x => x.id === props.productionOrder.machineIdPlanned)
            let upperStatus = workstation.scissorStatuses.find(x => x.scissorName === scissorTypes.UPPER)
            let lowerStatus = workstation.scissorStatuses.find(x => x.scissorName === scissorTypes.LOWER)

            if (JSON.stringify(upperScissorStatus) !== JSON.stringify(upperStatus)) {
                setUpperScissorStatus(upperStatus)
            }
            if (JSON.stringify(lowerScissorStatus) !== JSON.stringify(lowerStatus)) {
                setLowerScissorStatus(lowerStatus)
            }
        }).catch((error) => { toast.error(error, { position: toast.POSITION.TOP_CENTER }) })

        dataService.getProductionOrdersByMachine(props.productionOrder.machineIdPlanned).then(productionOrders => {

            if (JSON.stringify(productionOrders) !== JSON.stringify(orders)) {
                setOrders(productionOrders)
            }

        }).catch((error) => { toast.error(error, { position: toast.POSITION.TOP_CENTER }) })

        dataService.getMachinesByMachineType(machineScissorZone).then(allZones => {
            if (JSON.stringify(allZones) !== JSON.stringify(scissorZones)) {
                setScissorZones(allZones)
            }

            dataService.getProductionOrdersByMachine(props.productionOrder.machineIdPlanned).then(orders => {

                let zones = [{ zone: "A", scissor: 1, used: false, orderId: null, orderRef: null },
                { zone: "B", scissor: 1, used: false, orderId: null, orderRef: null },
                { zone: "C", scissor: 1, used: false, orderId: null, orderRef: null },
                { zone: "D", scissor: 1, used: false, orderId: null, orderRef: null },
                { zone: "E", scissor: 1, used: false, orderId: null, orderRef: null },
                { zone: "F", scissor: 1, used: false, orderId: null, orderRef: null }]

                orders = orders.filter(o => o.productionOrderStatus === state.PLANNED || o.productionOrderStatus === state.PAUSED || o.productionOrderStatus === state.RUNNING)
                
                var o;
                var ro;
                //** SC: START --> Check if the running order on this workstation is active for the whole workstation + change all zones used if so  */
                var runningOrders = orders.filter(o => o.productionOrderStatus === state.PAUSED || o.productionOrderStatus === state.RUNNING)

                for(ro = 0; ro < runningOrders.length; ro++){
                    let runningBowMetaData = JSON.parse(runningOrders[ro].bowMetaData)
                    var az;
                    if(runningBowMetaData === null){
                        setCompleteWorkstationOrder(true)

                            for (az = 0; az < allZones.length; az++) {
                                var uz;
                                zones.find(uz => uz.zone === allZones[az].name).used = true
                                zones.find(uz => uz.zone === allZones[az].name).orderId = runningOrders[ro].id
                                zones.find(uz => uz.zone === allZones[az].name).orderRef = runningOrders[ro].reference
                           } 
                    
                    }

                }
                //** SC: END --> Check if the running order on this workstation is active for the whole workstation + change all zones used if so  */

    
                for (o = 0; o < orders.length; o++) {
                    if (orders[o].bowMetaData) {

                        let bowMetaData = JSON.parse(orders[o].bowMetaData);
                        let metaData = bowMetaData.find(x => x.MetaDataType === 1).MetaData[0];
                        var i;
                        if(metaData.UsedZones.length > 0){
                            for (i = 0; i < allZones.length; i++) {
                                var y;
                                for (y = 0; y < metaData.UsedZones.length; y++) {
                                    if (metaData.UsedZones[y].ZoneId === allZones[i].id) {
                                        if (allZones[i].code.includes(scissorTypes.LOWER)) {
                                            zones.find(x => x.zone === allZones[i].name).scissor = 0
                                        }
                                        zones.find(x => x.zone === allZones[i].name).used = true
                                        zones.find(x => x.zone === allZones[i].name).orderId = orders[o].id
                                        zones.find(x => x.zone === allZones[i].name).orderRef = orders[o].reference
                                    }
                                }                               
                            } 
                        }
                    }
                }

                if (JSON.stringify(zones) !== JSON.stringify(zonesWithScissors)) {
                    setZonesWithScissors(zones);
                }

            }).catch((error) => { toast.error(error, { position: toast.POSITION.TOP_CENTER }) })

        }).catch((error) => { toast.error(error, { position: toast.POSITION.TOP_CENTER }) })

    }, [props.productionOrder, props.orderRefresh]);

    function switchMultipleOrders() {
        setMultipleOrders(!multipleOrders)
    }

    function setZones(zone) {
        let tempZones = selectedZones.slice()
        if (tempZones.some(x => x.zone === zone.zone)) {
            let index = tempZones.indexOf(tempZones.find(x => x.zone === zone.zone))
            tempZones.splice(index, 1)
        }
        else {
            tempZones.push(zone)
            tempZones.find(x => x.zone === zone.zone).orderId = props.productionOrder.id
            tempZones.find(x => x.zone === zone.zone).orderRef = props.productionOrder.reference
        }

        setSelectedZones(tempZones)
    }

    function switchScissor(zone) {
        let tempZones = Object.assign([], selectedZones)
        if (tempZones.find(x => x.zone === zone.zone).scissor === 1) {
            tempZones.find(x => x.zone === zone.zone).scissor = 0
        }
        else {
            tempZones.find(x => x.zone === zone.zone).scissor = 1
        }
        tempZones.find(x => x.zone === zone.zone).orderId = props.productionOrder.id
        tempZones.find(x => x.zone === zone.zone).orderRef = props.productionOrder.reference

        setSelectedZones(tempZones)
    }

    const startOrder = (startProduction) => {

        if (startProductionOrder || startProduction === true) {
            let totalSelectedZones = selectedZones.concat(zonesWithScissors.filter(x => x.used))
            var i;
            let orderList = []

            if (!multipleOrders) {
                orderList.push('Order ' + props.productionOrder.reference)
            }
            else {
                for (i = 0; i < totalSelectedZones.length; i++) {
                    let scissor = ""
                    if (totalSelectedZones[i].scissor === 1) {
                        scissor = scissorTypes.UPPER.toLowerCase()
                    }
                    else {
                        scissor = scissorTypes.LOWER.toLowerCase()
                    }

                    orderList.push('Order ' + totalSelectedZones[i].orderRef + t(" on  ") + t(scissor) + t(" scissor from zone ") + totalSelectedZones[i].zone)
                }
            }

            setOrderStringList(orderList)
            setOrderLengthDialogOpen(false)
            setStartOrderDialogOpen(true)
        }
        else {
            setOrderLengthDialogOpen(false)
            addOrder(false)
        }
    }

    const checkLengthOfProductionOrders = (startProduction) => {
        if (multipleOrders && selectedZones.length > 0) {
            let totalSelectedZones = selectedZones.concat(zonesWithScissors.filter(x => x.used)).sort((a, b) => b.used - a.used);
            let ordersOnUpperScissor = [];
            let ordersOnLowerScissor = [];
            let orderToCheck = null;
            var i;
            for (i = 0; i < totalSelectedZones.length; i++) {
                if (totalSelectedZones[i].scissor === 1) {
                    ordersOnUpperScissor.push(orders.find(x => x.id === totalSelectedZones[i].orderId));
                }
                else {
                    ordersOnLowerScissor.push(orders.find(x => x.id === totalSelectedZones[i].orderId));
                }
            }

            var y;
            let upperLength = 0
            for (y = 0; y < ordersOnUpperScissor.length; y++) {

                if (y === 0) {
                    upperLength = JSON.parse(ordersOnUpperScissor[y].bomOut[0].productMetaData).find(x => x.MetaDataType === 1).MetaData[0].Length.Value;
                    orderToCheck = ordersOnUpperScissor[y];
                }

                if (JSON.parse(ordersOnUpperScissor[y].bomOut[0].productMetaData).find(x => x.MetaDataType === 1).MetaData[0].Length.Value !== upperLength) {
                    if (!zonesWithScissors.filter(x => x.used).some(x => x.orderId === ordersOnUpperScissor[y].id && x.scissor === 1)) {
                        setStartProductionOrder(startProduction);
                        setDialogContext(t("The length of order ") + ordersOnUpperScissor[y].reference + t(" does not match the length of order ") + orderToCheck.reference + t(" on the upper scissors!"));
                        setOrderLengthDialogOpen(true);
                        return;
                    }
                }
            }

            var z;
            let lowerLength = 0
            for (z = 0; z < ordersOnLowerScissor.length; z++) {

                if (z === 0) {
                    lowerLength = JSON.parse(ordersOnLowerScissor[z].bomOut[0].productMetaData).find(x => x.MetaDataType === 1).MetaData[0].Length.Value
                    orderToCheck = ordersOnLowerScissor[z]
                }

                if (JSON.parse(ordersOnLowerScissor[z].bomOut[0].productMetaData).find(x => x.MetaDataType === 1).MetaData[0].Length.Value !== lowerLength) {
                    if (!zonesWithScissors.filter(x => x.used).some(x => x.orderId === ordersOnLowerScissor[z].id && x.scissor === 0)) {
                        setStartProductionOrder(startProduction)
                        setDialogContext(t("The length of order ") + ordersOnLowerScissor[z].reference + t(" does not match the length of order ") + orderToCheck.reference + t(" on the lower scissors!"))
                        setOrderLengthDialogOpen(true)
                        return;
                    }
                }
            }
        }
        startOrder(startProduction)
    }

    const addOrStartOrderAfterIgnoreUnMatchingBOMIn = () => {
        addOrder(startProductionOrder,true)
    }

    function addOrder(startProduction,ignoreNotMatchingBOMIns) {
        //Check for running or paused orders 
        var i;
        let unMatchingBOMIn = false;

        for (i = 0; i < orders.length; i++) {
            if (orders[i].productionOrderStatus === state.RUNNING || orders[i].productionOrderStatus === state.PAUSED) {
                if (!zonesWithScissors.some(x => x.used)) {
                    setDialogTitle(t("Workstation ") + props.productionOrder.machineIdPlanned + t(" occupied!"));
                    setDialogContext(t("There are already running or paused orders on workstation ") + props.productionOrder.machineIdPlanned);
                    setRunningOrPausedDialogOpen(true);
                    return;
                }
                else {
                    if (!haveSameBOMIn(props.productionOrder, orders[i])) {
                        if(!ignoreNotMatchingBOMIns){
                            unMatchingBOMIn = true;
                        }
                    }
                }

            }
        }

        if (unMatchingBOMIn) {
            setStartProductionOrder(startProduction)
            setDialogTitle(t("Attention!"))
            setDialogContext("Order " + props.productionOrder.reference + t(" needs different materials than the running order(s)"))
            setUnMatchingBOMDialogOpen(true)
            return
        }

        if (multipleOrders) {
            let metaData = [{
                MetaDataType: 1,
                Version: 1,
                MetaData: [{
                    UsedZones: []
                }]
            }]

            let totalSelectedZones = selectedZones.concat(zonesWithScissors.filter(x => x.used && x.orderId === props.productionOrder.id))

            var i;
            for (i = 0; i < totalSelectedZones.length; i++) {
                let scissor = ""
                if (totalSelectedZones[i].scissor === 1) {
                    scissor = scissorTypes.UPPER
                }
                else {
                    scissor = scissorTypes.LOWER
                }
                let zone = scissorZones.find(x => x.name === totalSelectedZones[i].zone && x.code.includes(scissor) && x.code.includes(String(props.productionOrder.machinePlannedCode)))

                metaData.find(x => x.MetaDataType === 1).MetaData[0].UsedZones.push({
                    ZoneId: zone.id,
                    StartedOn: null,
                    FinishedOn: null
                })
            }
            dataService.updateZones(JSON.stringify(metaData), props.productionOrder.id, props.productionOrder.machineIdPlanned).then().catch((error) => { toast.error(error, { position: toast.POSITION.TOP_CENTER }) })
            props.refreshOrder()
            props.selectLine(props.productionOrder.machineIdPlanned, props.productionOrder.id)
        }

        if (startProduction) {
            startPlannedProductionOrders()
        }

        setSelectedZones([])
    }

    function startPlannedProductionOrders() {
        let tempZones = Object.assign([], zonesWithScissors.filter(x => x.used))
        if (!multipleOrders) {
            dataService.startProductionOrder(props.productionOrder.id, props.workstation.selectedWorkstation).then(setTimeout(() => { props.refreshOrder(); }, 2000)).catch((error) => { toast.error(error, { position: toast.POSITION.TOP_CENTER }) })
            cleanRemainingOrdersInZones(tempZones)
        }
        else {
            var i;
            for (i = 0; i < tempZones.length; i++) {
                dataService.startProductionOrder(tempZones[i].orderId, props.workstation.selectedWorkstation).then(setTimeout(() => { props.refreshOrder(); }, 2000)).catch((error) => { toast.error(error, { position: toast.POSITION.TOP_CENTER }) })
            }
            var y;
            for (i = 0; i < selectedZones.length; i++) {
                dataService.startProductionOrder(selectedZones[i].orderId, props.workstation.selectedWorkstation).then(setTimeout(() => { props.refreshOrder(); }, 2000)).catch((error) => { toast.error(error, { position: toast.POSITION.TOP_CENTER }) })
            }
        }
        setStartOrderDialogOpen(false)
        props.openDrawer(false)
    }

    function cleanRemainingOrdersInZones(zones) {
        //Delete orders added to zones 

        var i;
        var zonesToRemove = []
        for (i = 0; i < zones.length; i++) {

            let zoneToRemove = { zone: zones[i].zone, scissor: zones[i].scissor, orderId: zones[i].orderId }
            zonesToRemove.push(zoneToRemove)
        }

        props.removeAllOrdersFromAllZones(zonesToRemove)
    }

    function closeRunningOrPausedDialog() {
        setRunningOrPausedDialogOpen(false)
    }

    function closeStartOrderDialog() {
        setStartOrderDialogOpen(false)
    }

    function closeOrderLengthDialog() {
        setStartProductionOrder(false)
        setOrderLengthDialogOpen(false)
    }

    function closeUnMatchingBomDialog() {
        setUnMatchingBOMDialogOpen(false)
    }

    return <Drawer variant="temporary" className={classes.drawer} anchor='right' open={props.drawerOpen} classes={{ paper: clsx({ [classes.drawerOpen]: props.drawerOpen, [classes.drawerClose]: !props.drawerOpen, }), }} onClose={() => props.openDrawer(false)} transitionDuration={500}>
        <div className={classes.drawerBody}>
            <div className={classes.header}>
                <div className={classes.title}>Order status</div>
                <div className={classes.close}>
                    <Button className={classes.closeButton} onClick={() => props.openDrawer(false)}>
                        <CloseIcon className={classes.closeButtonIcon}></CloseIcon>
                    </Button>
                </div>
            </div>
            <div className={classes.body}>
                <div className={classes.switchContainer}>
                    <Switch className={classes.multipleOrdersSwitch}
                        checked={multipleOrders && completeWorkstationOrder === false}
                        onChange={switchMultipleOrders}
                        name="multipleOrders"
                        disabled={orders.some(x => x.productionOrderStatus === state.RUNNING || x.productionOrderStatus === state.PAUSED) && zonesWithScissors.some(x => x.used)}
                    />
                    <div className={classes.switchText}>{t("Run multiple orders on this machine")}</div>
                </div>
                {multipleOrders && upperScissorStatus && lowerScissorStatus && completeWorkstationOrder === false ? <React.Fragment>
                    <SelectZoneContainer zonesWithScissors={zonesWithScissors} {...props} productionOrder={props.productionOrder} selectedZones={selectedZones} setZones={setZones}></SelectZoneContainer>
                    <SelectScissorsContainer zonesWithScissors={zonesWithScissors} upperScissorStatus={upperScissorStatus} lowerScissorStatus={lowerScissorStatus} {...props} productionOrder={props.productionOrder} selectedZones={selectedZones} switchScissor={switchScissor}></SelectScissorsContainer>
                    <div className={classes.addOrder}>{selectedZones.length !== 0 ? <button className={classes.addOrderButton} onClick={() => checkLengthOfProductionOrders(false)}>{t("ADD ORDER")}</button> : <React.Fragment></React.Fragment>}</div>
                </React.Fragment> :
                    <React.Fragment></React.Fragment>}
                    
                <div className={classes.startProduction}>
                    {!zonesWithScissors.some(x => x.used) && selectedZones.length === 0 && multipleOrders ? <React.Fragment></React.Fragment> : 
                        <button 
                        disabled={(orders.some(x => x.productionOrderStatus === state.RUNNING || x.productionOrderStatus === state.PAUSED)) && (zonesWithScissors.some(x => x.used) && (zonesWithScissors.filter(x => x.orderRef === props.productionOrder.reference).length === 0))} 
                        className={((orders.some(x => x.productionOrderStatus === state.RUNNING || x.productionOrderStatus === state.PAUSED)) && (zonesWithScissors.some(x => x.used) && (zonesWithScissors.filter(x => x.orderRef === props.productionOrder.reference).length === 0)) ? classes.startProductionButtonDisabled : classes.startProductionButton)} 
                            onClick={() => checkLengthOfProductionOrders(true)}> 
                            <PlayArrowRoundedIcon className={classes.start}></PlayArrowRoundedIcon> 
                            <div className={classes.startProductionText}>
                                {t("START PRODUCTION")}
                            </div>
                        </button>
                    }
                </div>
                {multipleOrders && completeWorkstationOrder === false ? <div className={classes.usedZoneList}>
                    {zonesWithScissors.filter(x => x.used).map((z, index)=> {
                        return (
                            <div key={index} className={classes.usedZone}>
                                {"Zone " + z.zone + ": " + z.orderRef + " "}
                                <button className={classes.removeOrderFromZoneButton} onClick={() => props.openDeleteOrderFromZoneDialog(z.zone, z.scissor, z.orderRef, z.orderId)}>{" X"}</button>
                            </div>)
                    })}
                </div> : <React.Fragment></React.Fragment>}
                <OrderLengthDialog {...props} dialogOpen={orderLengthDialogOpen} closeDialog={closeOrderLengthDialog} action={() => startOrder} dialogContext={dialogContext}></OrderLengthDialog>
                <UnMatchingBOMDialog {...props}  dialogOpen={unMatchingBOMDialogOpen} closeDialog={closeUnMatchingBomDialog} action={() => addOrStartOrderAfterIgnoreUnMatchingBOMIn} dialogContext={dialogContext} dialogTitle={dialogTitle}></UnMatchingBOMDialog>
                <StartOrderDialog {...props} dialogOpen={startOrderDialogOpen} closeDialog={closeStartOrderDialog} orderList={orderStringList} action={() => addOrder} dialogTitle={dialogTitle} dialogContext={dialogContext}></StartOrderDialog>
                <AlertDialog {...props} dialogOpen={runningOrPausedDialogOpen} action={closeRunningOrPausedDialog} dialogTitle={dialogTitle} dialogContext={dialogContext}></AlertDialog>
            </div>
        </div>
    </Drawer>
}

const useStyles = makeStyles(() => ({
    drawerBody: {
        width: "100%",
        height: "100%",
        background: 'linear-gradient(#EFEFEF,#FFFFFF)',
        paddingLeft: "15px",
        paddingRight: "10px",
        paddingTop: "10px",
        boxSizing: "border-box"
    },
    closeButton: {
        float: 'right',
        "&:hover": {
            background: "#EFEFEF"
        },
        paddingRight: "0px !important",
        width: "25px !important",
        height: "25px !important",
        minWidth: "0px !important",
    },
    closeButtonIcon: {
        marginRight: "6px"
    },
    drawerOpen: {
        width: "auto",
        minWidth: "380px"
    },
    drawerClose: {
        width: 0
    },
    close: {
        width: "20%",
        display: "inline-block",
        verticalAlign: "top"
    },
    title: {
        width: "80%",
        fontSize: "32px",
        fontFamily: "Lato, sans-serif",
        fontWeight: 'Medium',
        color: "#000000",
        marginTop: "10px",
        paddingLeft: "8px",
        display: "inline-block",
        boxSizing: "border-box"
    },

    header: {
        width: "100%",
        height: "auto",
        marginBottom: "20px"
    },
    switchText: {
        float: "left",
        fontSize: "14px",
        fontFamily: "Lato, sans-serif",
        fontWeight: 'Medium',
        color: "#020100",
        paddingTop: "10px"
    },
    multipleOrdersSwitch: {
        float: "left",
        height: "48px",
        width: "65px",
        '& .MuiSwitch-track': {
            backgroundColor: "#00000029",
            opacity: "1",
            position: "relative",
            bottom: "5px",
            right: "4px",
            borderRadius: "15px"
        },
        '& .MuiSwitch-colorSecondary.Mui-checked + .MuiSwitch-track': {
            backgroundColor: "#5CC958",
            opacity: "1",
            position: "relative",
            bottom: "5px",
            right: "2px",
            borderRadius: "15px"
        }
    },
    switchContainer: {
        width: "100%",
        height: "50px"
    },
    addOrder: {
        width: "100%",
        textAlign: "center",
        marginBottom: "10px",
        marginTop: "30px"
    },
    addOrderButton: {
        width: "200px",
        height: "40px",
        borderRadius: "5px",
        outline: "none",
        border: "none",
        cursor: "pointer",
        fontSize: "14px",
        fontFamily: "Lato, sans-serif",
        color: "white",
        textAlign: "center",
        backgroundColor: FlagstoneTheme.palette.primary.main
    },
    startProductionButton: {
        width: "200px",
        height: "40px",
        borderRadius: "5px",
        outline: "none",
        border: "none",
        cursor: "pointer",
        fontSize: "14px",
        fontFamily: "Lato, sans-serif",
        color: "white",
        textAlign: "center",
        backgroundColor: "#5CC958",
    },
    startProductionButtonDisabled: {
        width: "200px",
        height: "40px",
        borderRadius: "5px",
        outline: "none",
        border: "none",
        fontSize: "14px",
        fontFamily: "Lato, sans-serif",
        color: "white",
        textAlign: "center",
        backgroundColor: "#cccccc",
    },
    startProduction: {
        width: "100%",
        textAlign: "center"
    },
    start: {
        color: "white",
        height: "30px",
        width: "30px",
        float: "left"
    },
    startProductionText: {
        float: "left",
        paddingTop: "6px",
        marginLeft: "8px"
    },
    removeOrderFromZoneButton: {
        border: "none",
        outline: "none",
        cursor: "pointer",
        fontSize: "16px",
        fontFamily: "Lato, sans-serif",
        backgroundColor: "rgb(1,1,1,0)",
        fontWeight: 'bold',
        marginBottom: "5px"
    },
    usedZone: {
        fontSize: "18px",
        fontFamily: "Lato, sans-serif",
        width: "100%",
        textAlign: "center",
        marginBottom: "5px"
    },
    usedZoneList: {
        marginTop: "50px"

    }
}));